export default __webpack_public_path__ + "static/media/s4_scape4.90eaefeb.png";